
  import { Delegation } from '@/services/api/models'
  import { defineComponent } from 'vue'
  import moment from 'moment'
  import { formatNumber } from '@/utils'
  export default defineComponent({
    name: 'DelegationCard',
    props: {
      event: {
        type: Object as () => Delegation | undefined,
        default: null
      }
    },
    setup() {
      return { moment, formatNumber }
    }
  })
